import { Box } from "@material-ui/core";
import { TopBox } from "../../../../components/TopBox";
import { BotBox } from "../../../../components/BotBox";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useStyles } from "../../quoteDetail.styles";
import { ElectricityAnalysis } from "./ElectricityAnalysis";
import { SwyftNews } from "./SwyftNews/SwyftNews";

export const ElectricityAnalysisSection = ({ hasSpecialBackground }: { hasSpecialBackground?: boolean }) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const classes = useStyles();

  return (
    <Box bgcolor={hasSpecialBackground ? "#f7f7f7" : "#fff"} mt={"92px"} position={"relative"}>
      {hasSpecialBackground && (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <SwyftNews />
      <Box
        textAlign="center"
        fontSize={isMoreThanSm ? "28px" : "20px"}
        color="#1e073f"
        fontWeight={500}
        width="100%"
        mt={isMoreThanSm ? 6 : 0}
        mb={isMoreThanSm ? 4 : 0}
      >
        See your <span className={classes.colorOrange}>live</span> electricity analysis
      </Box>
      <ElectricityAnalysis />
      {hasSpecialBackground && (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};
